import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setThemeName } from 'stores/layoutSlice';

const useChangeTheme = () => {
	const dispatch = useDispatch();

	const changeTheme = useCallback((themeName) => {
		dispatch(setThemeName(themeName));
	}, []);

	return changeTheme;
};

export default useChangeTheme;
